import { render, staticRenderFns } from "./CpOrderView.vue?vue&type=template&id=5d8bc006"
import script from "./CpOrderView.vue?vue&type=script&lang=js"
export * from "./CpOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports